export const productOperationsList = {
  newProduct: "NEW_PRODUCT",
  updateProduct: "UPDATE_PRODUCT",
  listProduct: "LIST_PRODUCT",
  previewProduct: "PREVIEW_PRODUCT",
  productTask: "PRODUCT_TASK",
  productAssignToPmc: "PRODUCT_PMC_ASSIGN",
  productPMCHandover: "PRODUCT_PMC_HANDOVER",
  productExecutionTimeline: "PRODUCT_EXECUTION_TIMELINE",
  editProductExecutionTimeline: "EDIT_PRODUCT_EXECUTION_TIMELINE",
  productInputOutputDetails: "PRODUCT_INPUT_OUTPUT",
  pmcHandoverChecklistPreview: "PMC_HANDOVER_CHECKLIST_PREVIEW",
  executionTimelinePreview: "EXECUTION_TIMELINE_PREVIEW",
};

export const PROJECT_STATUS = {
  ENQUIRY: "Enquiry",
  MOCK_UP_REQUIRED: "Mock-Up",
  REGISTER_PROJECT: "Register",
};

export const PRODUCT_FORM_LABELS = {
  isPcdRequired: "Required to add in library",
  isLot: "Are you sending this product in lots or parts?",
  partCount: "How many parts are there in this products?",
  lotCount: "How many lots are there in this part?",
  partCountAndLotCountMismatch:
    "There is a difference in the part quantity and total lot quantity. Are you aware of this?",
  countOfLotEachPart: "Fill the lot count for each part",
};

export const EXECUTION_TIMELINE_FIELDS = {
  handover: "Handover",
  shopDrawing: "Shop Drawing",
  clientApprovalSd: "Client Approval Sd",
  shopDrawingRevision: "Shop Drawing Revision",
  clientApprovalSdr: "Client Approval Sdr",
  proto: "Proto",
  clientApprovalP: "Client Approval P",
  protoRevision: "Proto Revision",
  clientApprovalPr: "Client Approval Pr",
  pcd: "Pcd",
  protoProduction: "Proto Production",
  production: "Production",
  specificPurchase: "Specific Purchase",
  buffer: "Buffer",
};
export const EXECUTION_TIMELINE_TEMPLATES = [
  {
    name: "Standard Days",
    timeline: {
      handover: 2,
      shopDrawing: 7,
      clientApprovalSd: 2,
      shopDrawingRevision: 4,
      clientApprovalSdr: 2,
      proto: 30,
      clientApprovalP: 2,
      protoRevision: 9,
      clientApprovalPr: 2,
      pcd: 8,
      protoProduction: 0,
      production: 60,
      specificPurchase: 0,
      buffer: 0,
    },
  },
  {
    name: "Cookie Cutter Days",
    timeline: {
      handover: 2,
      shopDrawing: 7,
      clientApprovalSd: 2,
      shopDrawingRevision: 4,
      clientApprovalSdr: 2,
      proto: 30,
      clientApprovalP: 2,
      protoRevision: 9,
      clientApprovalPr: 2,
      pcd: 5,
      protoProduction: 0,
      production: 45,
      specificPurchase: 0,
      buffer: 0,
    },
  },
  {
    name: "Days for Acceptance",
    timeline: {
      handover: 0,
      shopDrawing: 1,
      clientApprovalSd: 0,
      shopDrawingRevision: 1,
      clientApprovalSdr: 0,
      proto: 1,
      clientApprovalP: 0,
      protoRevision: 1,
      clientApprovalPr: 0,
      pcd: 1,
      protoProduction: 0,
      production: 3,
      specificPurchase: 0,
      buffer: 0,
    },
  },
];

export const EARLY_DELIVERY_OPTIONS = {
  preferred: "Preferred",
  no: "No",
};

export const PRODUCT_REFERENCE_TYPE = [
  { option: "NEW", value: "New" },
  { option: "PCD", value: "Library" },
  { option: "VARIANT", value: "Variant" },
];

export const EXCLUDED_ITEMS_FROM_CHECKLIST = [
  "checklistId",
  "checklistApprovalStatus",
  "checklistApprovedBy",
  "checklistApprovedOn",
];

export const CONTEXT_MENU_LABELS = {
  COPY_HANDOVER_CHECKLIST: "Copy Handover Checklist",
  COPY_EXECUTION_TIMELINE: "Copy Execution Timeline",
  DELETE_ROW: "Delete Product",
  EDIT_ROW: "Edit Product",
  EDIT_EXECUTION_TIMELINE: "Edit Execution Timeline",
  EDIT_HANDOVER_CHECKLIST_TIMELINE: "Edit Handover Checklist",
};
